module.exports = __webpack_public_path__ + "media/img/corporate/logos/sbb-a77d9073cff342ba98fcfe2b309ad2e3.svg";